const ENFinancialManagementAccounting = {
	"Cada linha do arquivo é composta das seguintes informações (separados pelo delimitador)": "Each line in the file is made up of the following information (separated by the delimiter)",
	"Conta contábil": "Accounting account",
	"Crédito": "Credit",
	"Débito": "Debt",
	"Erro ao excluir valor contábil": "Error deleting accounting value",
	"Excluir itens selecionados": "Delete selected items",
	"Importar valores contábeis": "Import accounting values",
	"Integrado": "Integrated",
	"Item contábil": "Accounting item",
	"Limpar itens selecionados": "Clear selected items",
	"Não foi possível identificar o crédito": "Cannot identify credit",
	"Não foi possível identificar o débito": "Cannot identify debt",
	"Não foi possível identificar o saldo": "Cannot identify balance",
	"Saldo": "Balance",
	"Selecionar valores contábeis": "Select accounting values",
	"Valores contábeis": "Accounting Values",
	"Valor contábil excluído com sucesso": "Accounting value deleted successfully"
};

export default ENFinancialManagementAccounting;
